
import { createSlice } from '@reduxjs/toolkit';
import { organizationApi } from '@/redux/RTK/OragnizationsQuerys/organisation';

const initialState = {
  byCompany: {}, // { [companyID]: data }
  lastLoadedCompanyID: null,
};

const requestKindMenuOptionsSlice = createSlice({
  name: 'requestKindMenuOptions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      organizationApi.endpoints.getRequestKindMenuOptions.matchFulfilled,
      (state, { meta, payload }) => {
        // meta.arg.originalArgs is the companyID passed to the query
        const companyID = meta?.arg?.originalArgs;
        if (companyID != null) {
          state.byCompany[companyID] = payload?.data ?? payload;
          state.lastLoadedCompanyID = companyID;
        }
      }
    );
  },
});

export default requestKindMenuOptionsSlice.reducer;